import type { SupportedLanguage } from './languageConfig';

const NATIONALITY_MAP: Record<string, SupportedLanguage> = {
  // Dutch forms (as stored in backend)
  'nederlandse': 'nl',
  'britse': 'en',
  'poolse': 'pl',
  'roemeense': 'ro',
  'bulgaarse': 'bg',
  'hongaarse': 'hu',
  'duitse': 'de',
  'spaanse': 'es',
  'portugese': 'pt',
  'oekraïense': 'uk',
  'turkse': 'tr',
  'litouwse': 'lt',
  'tsjechische': 'cs',
  'slowaakse': 'sk',

  // English forms
  'dutch': 'nl',
  'british': 'en',
  'english': 'en',
  'polish': 'pl',
  'romanian': 'ro',
  'bulgarian': 'bg',
  'hungarian': 'hu',
  'german': 'de',
  'spanish': 'es',
  'portuguese': 'pt',
  'ukrainian': 'uk',
  'turkish': 'tr',
  'lithuanian': 'lt',
  'czech': 'cs',
  'slovak': 'sk',

  // Country names / demonyms
  'nederland': 'nl',
  'netherlands': 'nl',
  'poland': 'pl',
  'polen': 'pl',
  'romania': 'ro',
  'roemenië': 'ro',
  'bulgaria': 'bg',
  'bulgarije': 'bg',
  'hungary': 'hu',
  'hongarije': 'hu',
  'germany': 'de',
  'duitsland': 'de',
  'spain': 'es',
  'spanje': 'es',
  'portugal': 'pt',
  'ukraine': 'uk',
  'oekraïne': 'uk',
  'turkey': 'tr',
  'turkije': 'tr',
  'lithuania': 'lt',
  'litouwen': 'lt',
  'czech republic': 'cs',
  'czechia': 'cs',
  'tsjechië': 'cs',
  'slovakia': 'sk',
  'slowakije': 'sk',
  'united kingdom': 'en',
  'great britain': 'en',
  'verenigd koninkrijk': 'en',
  'groot-brittannië': 'en',
};

export function nationalityToLanguage(nationality?: string | null): SupportedLanguage | null {
  if (!nationality) return null;
  return NATIONALITY_MAP[nationality.toLowerCase().trim()] ?? null;
}
